import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {JSONCards} from "./CardStruct";



@Injectable({
  providedIn: 'root'
})
export class CardLayoutDataService {
  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(filelink: number): Observable<JSONCards> {
    this.uiUrl = this.url.GetDepartmentUrl() + "/" + filelink;
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<JSONCards>(this.uiUrl);
  }


}

